import { queryOptions } from '@tanstack/react-query'

import { CheckoutAvailabilityService } from '@inter-ikea-kompis/services'
import type { IDexfSettings, IProductItem } from '@inter-ikea-kompis/types'

import type { ProductData } from '@sofa-platform/types'

import { KOMPIS_SERVICE_BASE_SETTINGS } from '@/integrations/kompis/constants'

export function zipAvailabilitiesQueryOptions(
  dexfSettings: IDexfSettings,
  productData: ProductData,
  zipCode: string | null,
) {
  return queryOptions({
    enabled: zipCode !== undefined,
    queryFn: async () => await fetchZipAvailabilities(dexfSettings, productData, zipCode),
    queryKey: ['zip-availabilities', zipCode, productData.itemId],
  })
}

async function fetchZipAvailabilities(dexfSettings: IDexfSettings, productData: ProductData, zipCode: string | null) {
  if (!zipCode) return []
  const checkoutAvailabilityService = new CheckoutAvailabilityService({
    ...KOMPIS_SERVICE_BASE_SETTINGS,
    settings: dexfSettings,
  })

  const productItems: IProductItem[] = [{ id: productData.content.ruItemNo, type: productData.content.ruItemType }]

  return await checkoutAvailabilityService.getZipAvailabilities(zipCode, productItems)
}
